var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-button-new",on:{"click":_vm.newInfo}},[_vm._v("\n  新しいお知らせの作成\n")])}
var staticRenderFns = []

export { render, staticRenderFns }